import {
    WrapperControls,
    WrapperOptions,
    renderInstreamTemplate,
} from '@/modules/adv/providers/google-instream-ads/template/instream-template'

export type Wrapper = {
    controls: WrapperControls
    wrapper: HTMLDivElement
}

export function renderWrapper(options: WrapperOptions): Wrapper {
    try {
        const { wrapper, controls } = renderInstreamTemplate(options)
        document.body.insertAdjacentElement('beforeend', wrapper)
        return { controls, wrapper }
    } catch (e) {
        throw new Error(`Cannot create the google instream wrapper app due to error: ${e}`)
    }
}
